import { isAfter } from 'date-fns';
import { FC, useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import KioskInactivityChecker from 'containers/KioskInactivityChecker';
import { CartProvider } from 'context/CartContext';
import { CategoryProvider } from 'context/CategoryContext';
import { LocationContextProvider } from 'context/LocationContext';
import { PaymentProvider } from 'context/PaymentContext';
import { UserContext } from 'context/UserContext';

import { useKiosk } from 'hooks/useKiosk';
import { getUserAnonToken } from 'services/User';

import { handleApiErrors } from 'utils/errorUtils';
import { deleteAnonAuthFromStorage, getAnonAuth, setAnonAuthToStorage } from 'utils/storageUtils';

const GlobalProvider:FC = () => {
  const { managementMode, kioskMode } = useKiosk();
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (managementMode && user?.uid) {
      const storageAnonAuth = getAnonAuth();

      if (storageAnonAuth && isAfter(storageAnonAuth?.expiresAt, new Date().getTime())) {
        return;
      }

      deleteAnonAuthFromStorage();
      fetchAnonToken(user?.uid);
    }
  }, [managementMode, user?.uid]);

  const fetchAnonToken = async (userId: string) => {
    try {
      const responseAnonToken = await getUserAnonToken(userId);
      setAnonAuthToStorage(responseAnonToken?.data);
    } catch (e) {
      handleApiErrors(e);
    }
  };

  return (
    <LocationContextProvider>
      <CartProvider>
        <CategoryProvider>
          <PaymentProvider>
            <Outlet />
            {kioskMode && !managementMode && <KioskInactivityChecker />}
          </PaymentProvider>
        </CategoryProvider>
      </CartProvider>
    </LocationContextProvider>
  );
};

export default GlobalProvider;
